import type { FC } from 'react';
import React from 'react';

import { CommonPhoneInput } from './common-phone-input';
import { validatePhone } from './helpers';
import type { IPropsX5BankPhoneInput } from './models';

export const X5BankPhoneInput: FC<IPropsX5BankPhoneInput> = ({ ...props }) => {
    return <CommonPhoneInput {...props} validatePhone={validatePhone} />;
};
